export const VARIANT_TYPE_INPUT_NAME = {
  color: 'Color',
  material: 'Material',
  size: 'Talla'
}

export const VARIANT_TYPE_QUANTITY_FORM = {
  color: {
    singular: 'Color disponible',
    plural: 'Colores disponibles',
    disabled_quantity: 'Elige un color para poder seleccionar la cantidad'
  },
  material: {
    singular: 'Material disponible',
    plural: 'Materiales disponibles',
    disabled_quantity: 'Elige un material para poder seleccionar la cantidad'
  },
  size: {
    singular: 'Talla disponible',
    plural: 'Tallas disponibles',
    disabled_quantity: 'Elige una talla para poder seleccionar la cantidad'
  }
}
